(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_util/debounce", "./assets/search.png", "./assets/search-dark.png", "./assets/clear-icon.png", "./assets/clear-icon-dark.png"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_util/debounce"), require("./assets/search.png"), require("./assets/search-dark.png"), require("./assets/clear-icon.png"), require("./assets/clear-icon-dark.png"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.debounce, global.search, global.searchDark, global.clearIcon, global.clearIconDark);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _debounce, _search, _searchDark, _clearIcon, _clearIconDark) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _debounce = _interopRequireDefault(_debounce);
  _search = _interopRequireDefault(_search);
  _searchDark = _interopRequireDefault(_searchDark);
  _clearIcon = _interopRequireDefault(_clearIcon);
  _clearIconDark = _interopRequireDefault(_clearIconDark);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', [_c('div', {
        class: "nx-search-" + _vm.type
      }, [_c('div', {
        class: "nx-search-" + _vm.type + "-detail",
        style: _vm.type == 'frame' ? '' : {
          'border-color': _vm.isDark ? _vm.contentLineColorDark : _vm.contentLineColor
        }
      }, [_c('img', {
        class: "nx-search-" + _vm.type + "-detail-icon",
        attrs: {
          "src": _vm.isDark ? _vm.leftIconDark : _vm.leftIcon,
          "alt": ""
        }
      }), _c('div', {
        class: "nx-search-" + _vm.type + "-detail-box"
      }, [(_vm.isNumber ? 'number' : 'text') === 'checkbox' ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        ref: "inputEl",
        class: "nx-search-" + _vm.type + "-detail-input",
        style: {
          'text-align': _vm.inputAlign
        },
        attrs: {
          "autocomplete": "off",
          "placeholder": _vm.placeholder,
          "maxlength": _vm.maxlength,
          "autofocus": _vm.autofocus,
          "disabled": _vm.disabled,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.inputBindValue) ? _vm._i(_vm.inputBindValue, null) > -1 : _vm.inputBindValue
        },
        on: {
          "input": _vm.$_onInput,
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": function keyup($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }

            return _vm.enterSearch($event);
          },
          "change": function change($event) {
            var $$a = _vm.inputBindValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;

            if (Array.isArray($$a)) {
              var $$v = null,
                  $$i = _vm._i($$a, $$v);

              if ($$el.checked) {
                $$i < 0 && (_vm.inputBindValue = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.inputBindValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.inputBindValue = $$c;
            }
          }
        }
      }) : (_vm.isNumber ? 'number' : 'text') === 'radio' ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        ref: "inputEl",
        class: "nx-search-" + _vm.type + "-detail-input",
        style: {
          'text-align': _vm.inputAlign
        },
        attrs: {
          "autocomplete": "off",
          "placeholder": _vm.placeholder,
          "maxlength": _vm.maxlength,
          "autofocus": _vm.autofocus,
          "disabled": _vm.disabled,
          "type": "radio"
        },
        domProps: {
          "checked": _vm._q(_vm.inputBindValue, null)
        },
        on: {
          "input": _vm.$_onInput,
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": function keyup($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }

            return _vm.enterSearch($event);
          },
          "change": function change($event) {
            _vm.inputBindValue = null;
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        ref: "inputEl",
        class: "nx-search-" + _vm.type + "-detail-input",
        style: {
          'text-align': _vm.inputAlign
        },
        attrs: {
          "autocomplete": "off",
          "placeholder": _vm.placeholder,
          "maxlength": _vm.maxlength,
          "autofocus": _vm.autofocus,
          "disabled": _vm.disabled,
          "type": _vm.isNumber ? 'number' : 'text'
        },
        domProps: {
          "value": _vm.inputBindValue
        },
        on: {
          "input": [function ($event) {
            if ($event.target.composing) {
              return;
            }

            _vm.inputBindValue = $event.target.value;
          }, _vm.$_onInput],
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": function keyup($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }

            return _vm.enterSearch($event);
          }
        }
      })]), _vm.clearable ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isShowClear,
          expression: "isShowClear"
        }],
        staticClass: "nx-search-clear",
        class: "nx-search-" + _vm.type + "-detail-clear",
        on: {
          "click": _vm.$_clearInput
        }
      }, [_c('i', {
        staticClass: "clear-icon"
      }, [_c('img', {
        attrs: {
          "src": _vm.isDark ? _vm.clearIconDark : _vm.clearIcon,
          "alt": ""
        }
      })])]) : _vm._e()]), _vm.type == 'default' && _vm.cancelShow ? _c('div', [_c('div', {
        staticClass: "nx-search-default-text",
        class: {
          'nx-search-default-text-active': _vm.isShowActionText
        },
        style: {
          'pointer-events': _vm.isShowActionText ? 'auto' : 'none',
          color: (_vm.isDark ? _vm.actionTextColorDark : _vm.actionTextColor) || '#333333'
        },
        on: {
          "click": _vm.cancel
        }
      }, [_vm._v("\n        " + _vm._s(_vm.actionText) + "\n      ")]), _c('div', {
        staticClass: "nx-search-default-cancel",
        class: {
          'nx-search-default-cancel-active': _vm.isShowActionText
        },
        style: {
          'border-color': _vm.isDark ? _vm.rightLineColorDark : _vm.rightLineColor
        }
      }, [_c('span', {
        staticClass: "nx-search-default-cancel-space"
      }, [_vm._v(_vm._s(_vm.actionText))])])]) : _vm._e(), _vm.type == 'frame' && _vm.cancelShow ? _c('div', {
        staticClass: "nx-search-frame-text",
        style: {
          color: (_vm.isDark ? _vm.actionTextColorFrameDark : _vm.actionTextColor) || '#3D90FF'
        },
        on: {
          "click": _vm.cancelFrame
        }
      }, [_vm._v("\n      " + _vm._s(_vm.actionText) + "\n    ")]) : _vm._e()])]);
    },
    name: 'nx-search',
    props: {
      // 类型
      type: {
        type: String,
        default: 'default' // default、frame

      },
      isNumber: {
        type: Boolean,
        default: false
      },
      // 输入的最大字符数	(number | string)
      maxlength: {
        type: [String, Number],
        default: '' // default、frame

      },
      // 占位提示文字
      placeholder: {
        type: String,
        default: '搜索'
      },
      // 是否启用清除图标，点击清除图标后会清空输入框
      clearable: {
        type: Boolean,
        default: true
      },
      // 显示清除图标的时机，always 表示输入框不为空时展示，focus 表示输入框聚焦且不为空时展示
      clearTrigger: {
        type: String,
        default: 'focus'
      },
      // 是否自动聚焦，iOS 系统不支持该属性
      autofocus: {
        type: Boolean,
        default: false
      },
      // action-text	右侧 取消按钮文字
      actionText: {
        type: String,
        default: '取消'
      },
      // action-text	右侧 取消按钮文字颜色
      actionTextColor: {
        type: String,
        default: ''
      },
      // action-text 深色模式	右侧 取消按钮文字颜色
      actionTextColorDark: {
        type: String,
        default: 'rgba(255, 255, 255, 0.9)'
      },
      actionTextColorFrameDark: {
        type: String,
        default: '#3e64e6'
      },
      // 是否禁用输入框
      disabled: {
        type: Boolean,
        default: false
      },
      // input-align 输入框内容对齐方式，可选值为 center right left
      inputAlign: {
        type: String,
        default: 'left',
        validator: function validator(value) {
          return ['center', 'right', 'left'].includes(value);
        }
      },
      // left-icon搜索图标图片链接
      leftIcon: {
        type: String,
        default: _search.default
      },
      leftIconDark: {
        type: String,
        default: _searchDark.default
      },
      // 清除图标
      clearIcon: {
        type: String,
        default: _clearIcon.default
      },
      clearIconDark: {
        type: String,
        default: _clearIconDark.default
      },
      // 内容区下划线颜色
      contentLineColor: {
        type: String,
        default: '#F0F0F0'
      },
      contentLineColorDark: {
        type: String,
        default: 'rgba(255, 255, 255, 0.15)'
      },
      // 右侧区下划线颜色
      rightLineColor: {
        type: String,
        default: '#505050'
      },
      rightLineColorDark: {
        type: String,
        default: 'rgba(255, 255, 255, 0.65)'
      },
      // 搜索方式 enter手动点击键盘enter触发 auto自动实时触发
      searchWay: {
        type: String,
        default: 'auto',
        validator: function validator(value) {
          return ['enter', 'auto'].includes(value);
        }
      },
      value: {
        type: [String, Number],
        default: ''
      },
      // 是否聚焦
      isFocus: {
        type: Boolean,
        default: false
      },
      // 是否展示取消按钮
      cancelShow: {
        type: Boolean,
        default: true
      }
    },
    components: {},
    data: function data() {
      return {
        inputBindValue: '',
        isInputFocus: false,
        isShowActionText: false,
        isDark: false
      };
    },
    created: function created() {
      this.isShowActionText = this.autofocus ? true : false;
      var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';
      this.isDark = !nxThemeOff && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    },
    mounted: function mounted() {
      if (this.isFocus) {
        this.$refs.inputEl.focus();
      }
    },
    watch: {
      value: function value(val) {
        this.inputBindValue = String(val);
      },
      isFocus: function isFocus(val) {
        if (val) {
          this.$refs.inputEl.focus();
        }
      }
    },
    computed: {
      isInputEmpty: function isInputEmpty() {
        return !this.inputBindValue.length;
      },
      isShowClear: function isShowClear() {
        return this.clearTrigger == 'always' ? !this.isInputEmpty : !this.isInputEmpty && this.isInputFocus;
      }
    },
    methods: {
      enterSearch: function enterSearch() {
        this.searchWay == 'enter' && this.$emit('search', this.inputBindValue);
      },
      onSearch: (0, _debounce.default)(function (val) {
        this.$emit('search', val);
      }),
      $_onInput: function $_onInput(event) {
        this.inputBindValue = event.target.value;
        this.$emit('input', event.target.value);

        if (this.searchWay == 'auto') {
          this.onSearch(event.target.value);
        }
      },
      $_onFocus: function $_onFocus($event) {
        var _this = this;

        setTimeout(function () {
          _this.isInputFocus = true;
          _this.isShowActionText = true;

          _this.$emit('focus', $event);
        }, 100);
      },
      $_onBlur: function $_onBlur($event) {
        var _this2 = this;

        setTimeout(function () {
          _this2.isInputFocus = false;

          _this2.$emit('blur', $event);
        }, 100);
      },
      $_clearInput: function $_clearInput($event) {
        var _this3 = this;

        this.inputBindValue = '';
        this.$emit('input', '');
        this.$nextTick(function () {
          _this3.$emit('clear', $event);

          _this3.$el.querySelector(".nx-search-".concat(_this3.type, "-detail-input")).focus();
        });
      },
      cancel: function cancel() {
        var _this4 = this;

        this.inputBindValue && this.$emit('input', '');
        this.inputBindValue = '';
        this.isInputFocus = false;
        this.$nextTick(function () {
          _this4.isShowActionText = false;

          _this4.$emit('cancel');
        });
      },
      cancelFrame: function cancelFrame() {
        this.$emit('cancel');
      }
    }
  };
  _exports.default = _default;
});